import fetch from 'utils/fetch'

export const getChannelPkgList = params => {
    return fetch({
        url: '/channel/list',
        data: { ...params },
    })
}
